export default __webpack_public_path__ + "images/AL.94ea91a.png";